import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { clsx } from 'clsx';
const Button = forwardRef(({ variant = 'primary', size = 'md', isLoading = false, leftIcon, rightIcon, fullWidth = false, children, className, disabled, ...props }, ref) => {
    const baseClasses = [
        'inline-flex items-center justify-center',
        'font-medium rounded-md',
        'focus:outline-none focus:ring-2 focus:ring-offset-2',
        'transition-all duration-200',
        'disabled:cursor-not-allowed disabled:opacity-50'
    ];
    const variantClasses = {
        primary: [
            'bg-primary-600 text-white',
            'hover:bg-primary-700 focus:ring-primary-500',
            'border border-transparent'
        ],
        secondary: [
            'bg-white text-gray-700 border border-gray-300',
            'hover:bg-gray-50 focus:ring-primary-500'
        ],
        success: [
            'bg-success-600 text-white',
            'hover:bg-success-700 focus:ring-success-500',
            'border border-transparent'
        ],
        danger: [
            'bg-danger-600 text-white',
            'hover:bg-danger-700 focus:ring-danger-500',
            'border border-transparent'
        ],
        warning: [
            'bg-warning-600 text-white',
            'hover:bg-warning-700 focus:ring-warning-500',
            'border border-transparent'
        ],
        ghost: [
            'bg-transparent text-gray-600',
            'hover:bg-gray-100 focus:ring-gray-500',
            'border border-transparent'
        ],
        outline: [
            'bg-transparent text-gray-700 border-gray-300',
            'hover:bg-gray-50 focus:ring-gray-500',
            'border'
        ]
    };
    const sizeClasses = {
        xs: 'px-2.5 py-1.5 text-xs',
        sm: 'px-3 py-2 text-sm',
        md: 'px-4 py-2 text-sm',
        lg: 'px-4 py-2 text-base',
        xl: 'px-6 py-3 text-base'
    };
    const widthClasses = fullWidth ? 'w-full' : '';
    return (_jsxs("button", { ref: ref, disabled: disabled || isLoading, className: clsx(baseClasses, variantClasses[variant], sizeClasses[size], widthClasses, className), ...props, children: [isLoading && (_jsx("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2" })), leftIcon && !isLoading && (_jsx("span", { className: "mr-2", children: leftIcon })), children, rightIcon && !isLoading && (_jsx("span", { className: "ml-2", children: rightIcon }))] }));
});
Button.displayName = 'Button';
export default Button;
